import {
  ViewNewsAll,
  ViewNewsSelection,
  ViewPartner,
  ProjectsAll,
  SiaProjectsAll,
  ProjectsCampaign,
  EmployeesAll,
  PartnersAll,
  FoundationsAll,
  PartnersRelated,
  ProjectsRelated,
  SiaProjectsRelated,
  ViewSeriesAll,
  SeriesRelated,
  ViewAwards,
  ViewPlaylists,
  NewsRelated,
  ViewMemberStories,
  PageRelated,
  KPQuestionsAll,
  KPQAnswersAll,
  KPQAnswersRecent,
} from '../implementations';

const mappers = {
  views_block__fonds_op_naam_block_1: FoundationsAll,
  views_block__news_block_1: ViewNewsSelection,
  views_block__news_block_2: ViewNewsAll,
  views_block__employees_block_1: EmployeesAll,
  views_block__partners_block_1: ViewPartner,
  views_block__partners_block_2: PartnersAll,
  views_block__projects_block_1: ProjectsAll,
  views_block__employees_block: EmployeesAll,
  views_block__series_block: ViewSeriesAll,
  views_block__related_partners_block_1: PartnersRelated,
  views_block__related_projects_block_1: ProjectsRelated,
  views_block__related_news_block_1: NewsRelated,
  views_block__related_series_block_1: SeriesRelated,
  views_block__playlists_block: ViewPlaylists,
  views_block__awards_block_1: ViewAwards,
  views_block__member_stories_block_1: ViewMemberStories,
  views_block__campaign_projects_block_1: ProjectsCampaign,
  views_block__related_pages_block_1: PageRelated,
  views_block__related_sia_projects_block_1: SiaProjectsRelated,
  views_block__sia_projects_block: SiaProjectsAll,
  views_block__related_blogs_block_1: NewsRelated,
  views_block__blogs_block_1: ViewNewsAll,
  views_block__kp_recent_answers_block_1: KPQAnswersRecent,
  views_block__kp_answers_block_1: KPQAnswersAll,
  views_block__kp_answers_block_2: KPQAnswersAll,
  views_block__kp_questions_block_1: KPQuestionsAll,
  views_block__kp_questions_block_2: KPQuestionsAll,
};

export default mappers;
